"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./Option.scss");
const Option = _ref => {
  let {
    option,
    onSelect,
    onMouseOut,
    onMouseOver,
    isAvailable = true,
    isHighlighted = false
  } = _ref;
  const {
    isSelected,
    thumbnail,
    value,
    label
  } = option;
  const handleClick = event => {
    event.preventDefault();
    onSelect(event, option);
  };
  const handleMouseOut = () => {
    onMouseOut?.();
  };
  const handleMouseOver = () => {
    onMouseOver?.(option);
  };
  const className = (0, _classnames.default)('cds-VariantOption', {
    'cds-VariantOption--Selected': isSelected,
    'cds-VariantOption--Unavailable': !isAvailable,
    'cds-VariantOption--Highlighted': isHighlighted
  });
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "cds-VariantPicker-ListItem",
    onMouseLeave: handleMouseOut,
    onMouseOver: handleMouseOver
  }, /*#__PURE__*/_react.default.createElement("label", {
    className: className
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "cds-VariantOption-Selector",
    type: "radio",
    value: value,
    "aria-checked": isSelected,
    onClick: handleClick
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-VariantOption-Content"
  }, thumbnail && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-VariantOption-Thumbnail"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: thumbnail,
    alt: label,
    className: "cds-VariantOption-Image"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-VariantOption-Label"
  }, label))));
};
exports.Option = Option;
//# sourceMappingURL=Option.js.map